import passengerTypes from './passenger-types-enum';

const passengerTypeCopy = {
  [passengerTypes.ADULT]: 'APP_ADULT',
  [passengerTypes.CHILD]: 'APP_CHILD',
  [passengerTypes.INFANT]: 'APP_INFANT',
};

export default passengerTypeCopy;
